import React, { useEffect, useState, forwardRef } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import { fetchJSON } from "../../utilities/fetch";
import {calculateDate} from "../../utilities/dateTime";
import { usePageProps } from '../../context/PagePropContext';
import Image from "../Image";
import classNames from "classnames";
export interface IBlogMoreArticlesProps extends IEditableProps, IStyledProps {
    children;
    className?: string;
    dateType?: string;
}

function arrayToString(prop: string|string[]) {
    return Array.isArray(prop) ? prop.join('') : prop;
}

const BlogMoreArticles = forwardRef((props: IBlogMoreArticlesProps, ref: any) => {
    const { className, children, editorClassObj, cmsId, dateType } = props;
    const { pageType, blogCategory } = usePageProps(); 
    
    const [results, setResults] = useState([]);

    function getResults() {
        try {
            console.log("Fetching more articles for category:", blogCategory);
            const url = `${process.env.GATSBY_SOLR_SEARCH_URL}?q=&pt=blog&limit=2&cat=${blogCategory}`;
            const cacheBypassParam = `clientCacheBypass=${Math.floor(Date.now() / 900001)}`; // create a param to bypass the cache every 15 minutes

            fetchJSON<any[any]>(`${url}&${cacheBypassParam}`)
                .then((res) => {
                    console.log("More articles response:", res);
                    if (res.response.docs.length > 0) {
                        const articles = res.response.docs.map((acc) => {
                            return {
                                key: acc.id,
                                title: arrayToString(acc.title),
                                path: arrayToString(acc.path),
                                description: arrayToString(acc.description),
                                category: arrayToString(acc.category),
                                thumbnailSrc: `${process.env.GATSBY_MEDIA_URL}${arrayToString(acc.thumb_image_src)}`,
                                thumbnailAlt: arrayToString(acc.thumb_image_alt),
                                timestamp: acc.timestamp
                            }
                        });

                        setResults(articles);
                    }
                })
                .catch(err => {
                    console.log("Error fetching more articles:", err);
                    setResults([]);
                });
        } catch (error) {
            console.log(`Failed to get more articles`, error);
            setResults([]);
        }
    }

    useEffect(() => {
        getResults();
    }, [blogCategory, dateType]);

    return (
        <div data-id={cmsId} ref={ref} className={classNames("container content border-0", className, editorClassObj)}>
            <div className="row">
                <div className="col-lg-7 mx-auto px-xl-6 px-lg-5 px-4 col-lg">
                    <div className="row">
                        {results.map((article) => (
                            <div key={article.key} className="col-12 col-lg-6 mb-5">
                                <a data-test-id="image-link" href={article.path} className="mb-4 d-inline-block">
                                    <Image loading="lazy" dataTestId="blog-image" src={article.thumbnailSrc} alt={article.thumbnailAlt} className="thumbnail" />
                                </a>
                                <div className="d-flex flex-column">
                                    <div>
                                        <span className="text-muted h6 category">{article.category}</span>
                                        <span>&nbsp;•&nbsp;&nbsp;{calculateDate(article.timestamp, dateType, "MMMM d, yyyy")}</span>
                                    </div>
                                    <a data-test-id="title-link" href={article.path} className="title-link d-inline-block">
                                        <h3>{article.title}</h3>
                                    </a>
                                </div>
                                
                                
                            </div>
                        ))}
                    </div>
                </div>
                
            </div>
        </div>
    );
});

export default styled(BlogMoreArticles)`
    .title-link {
        color: #212121;
        text-decoration: none;
    }   
`;